export * from "./AdminSearchScore.styled";
